const React = require('react');

const {apiAdminRetailersStatistic} = require('../../../../api/admin/retailers');
const {LINK_ADMIN_ADD} = require("../../../../constants/links");
const {getAdminRetailersLink} = require("../../../../utils/adminLinkCtor");
const {AdminPageHeader} = require('../../../dumb/AdminHelpers/AdminLayout');
const LayoutA = require('../../../dumb/Layout/A');
const RetailersTable = require('./components/RetailersTable');
const openPopupRetailerCreate = require("./utils/openPopupRetailerCreate");

module.exports = () => {

  const isTestnet = ['localhost', 'dev'].some((key) => window.location.host.includes(key));

  return (
    <>
      <AdminPageHeader
        title="Retailers"
        statistic={{
          display: [
            {title: 'Total', dataKey: 'total'},
            {title: 'Current Month', dataKey: 'monthly'}
          ],
          request: () => (
            apiAdminRetailersStatistic()
                .then((res) => res.accounts_overview)
                .then((res) => ({
                  total: String(res.total),
                  monthly: String(res.this_month)
                }))
          )
        }}
        newUserData={{
          text: 'New Retailer',
          onClick: () => openPopupRetailerCreate()
        }}
      />
      <RetailersTable />
    </>
  );
};
